document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth >= 750) return;

  const products_on_page = document.getElementById('product-grid');
  let next_url = products_on_page?.dataset.nextUrl;
  
  const load_more_btn = document.querySelector('.load-more_btn');
  const load_more_spinner = document.querySelector('.load-more_spinner');
  const collection_pagination = document.querySelector('.product-count');

  if (!products_on_page || !load_more_btn) return;

  load_more_btn.addEventListener('click', loadMoreProducts);

  async function getNextPage() {
    if (!next_url) return null;
    try {
      let res = await fetch(next_url);
      if (!res.ok) throw new Error(`Error HTTP: ${res.status}`);
      return await res.text();
    } catch (error) {
      console.error("Error loading page", error);
      return null;
    }
  }
  
  async function loadMoreProducts() {
    if (!next_url) return;

    collection_pagination.style.display = 'none';
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'block';

    let nextPage = await getNextPage();
    if (!nextPage) {
      load_more_spinner.style.display = 'none';
      return;
    }
    
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
    const productgrid = nextPageDoc.getElementById('product-grid');

    if (!productgrid) {
      load_more_spinner.style.display = 'none';
      return;
    }

    const new_products = productgrid.querySelectorAll('.grid__item');

    if (new_products.length === 0) {
      load_more_spinner.style.display = 'none';
      return;
    }

    next_url = productgrid.dataset.nextUrl || null;

    new_products.forEach(product => {
      products_on_page.appendChild(product.cloneNode(true));
    });


    load_more_spinner.style.display = 'none';
    if (next_url) {
      load_more_btn.style.display = 'block';
    }
  }
});
